<template>
  <div class="form">
    <iframe v-if="reload" class="formInstance" id="formInstance" :src="src" style="height: 100vh;" frameborder="0"></iframe>
  </div>
</template>

<script>
  import { langCnOrEn } from '@/common/js/user';
  export default {
    name: 'UrlInstanceRender',
    props: {
      system: {
        type: String,
        default: '',
        required: true
      },
      routerLink: {
        type: String,
        default: '',
        required: true
      },
      noticeHeaderId: {
        type: String,
        default: ''
      },
      data: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        reload: true,
        // contentWindow: document.getElementById('formInstance').contentWindow,
        src: ''
      };
    },
    watch: {
      '$route' ({name}) {
          if (name.indexOf('wonderful') > -1) {
              this.iframeReload();
          }
      }
    },
    mounted() {
      this.iframeReload();
    },
    methods: {
        iframeReload () {
            this.reload = false;
            this.src = `//${this.system}/gn/#gscInt?url=${this.routerLink.replaceAll('-', '/')}&lang=${langCnOrEn(this.$i18n.locale)}&noticeHeaderId=${this.noticeHeaderId}&myIframe=myIframe`;
            setTimeout(() => {
                this.reload = true;
            }, 100);
        }
    }
  };
</script>

<style lang="less" scoped>
  .form{
    height:100%;
    width: 100%;
    iframe{
      height:100%;
      width: 100%;
    }
  }
</style>
